import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getQuestionsAndAnswers } from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import { defaultAnswerState, questionPresentationContent } from "../../../data/QuestionPresentation";
import { useSourceSystem } from "../../../hooks/useSourceSystem";
import { sortAnswers } from "../../helpers";

function useBodyworkQuestionCompact({ question }: { question: Question }) {
  const dispatch = useDispatch();
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const noDamageAnswer = question.answers[0];
  const noDamageAnswerID = noDamageAnswer.id;
  const answersForSelect = [...question.answers].slice(1);
  const sortedAnswersForSelect = sortAnswers(answersForSelect);
  const {
    sourceSystem: { analyticSearchParam }
  } = useSourceSystem();

  const {
    groupName,
    labelForSelect,
    component: { content }
  } = questionPresentationContent[question.id];

  let showSelectLabel;
  let showSelectValue!: number;

  if ("showSelectLabel" in content!) {
    ({ showSelectLabel, showSelectValue, } =
      content);
  }

  const [answer, setAnswer] = useState(defaultAnswerState);

  useEffect(() => {
    setAnswer(storedAnswer ? storedAnswer : null);
  }, [question.selectedAnswer, questionsAndAnswers, question.id, storedAnswer]);

  const handleAnswerChange = (answerId: number) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.updateConditionalAnswersSubmitted(question.id)
    );
    setAnswer([answerId]);
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({ [question.id]: [answerId] })
    );
  };

  return {
    noDamage: noDamageAnswerID,
    handleChange: handleAnswerChange,
    sortedAnswersForSelect,
    answer,
    labelForSelect: labelForSelect || "",
    groupName: groupName || "",
    questionString: question.content,
    noDamageLabel: noDamageAnswer.label,
    showSelectLabel,
    showSelectValue
  };
}

export default useBodyworkQuestionCompact;
